export default __webpack_public_path__ + "static/media/drag_drop_ico.792948ad.svg";